/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { DkvBrokerService } from './services/dkv-broker.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    DkvBrokerService,
    ApiConfiguration
  ],
})
export class DkvBrokerModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<DkvBrokerModule> {
    return {
      ngModule: DkvBrokerModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DkvBrokerModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DkvBrokerModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
